import {
  signUpIbanUrl,
  signInUrl,
  registrationTokenUrl,
  ipUrl,
} from '../constants/endpointUrls';

import Service from './Service';

class AuthService extends Service {
  signUp(
    departmentId,
    email,
    groupId,
    isSupervisor,
    name,
    password,
    positionId
  ) {
    const params = {
      departmentId,
      email,
      groupId,
      isSupervisor,
      name,
      password,
      positionId,
    };

    return this.postRequest(signUpIbanUrl, params);
  }

  signIn(email, password) {
    const params = { email, password };

    return this.postRequest(signInUrl, params);
  }

  sendRegistrationToken(name, email, appName) {
    const params = { email, appName, params: { name } };

    return this.postRequest(registrationTokenUrl, params);
  }

  getIp() {
    return this.getRequest(ipUrl);
  }
}

export default new AuthService();



// WEBPACK FOOTER //
// ./src/utils/services/AuthService.js